import React from "react";

import { withRouter } from "react-router-dom";

import { getBreakpoint } from "Common/Responsive";

import type { RouterHistory } from "react-router-dom";

type Props = {
  children: React.ReactNode;
  history: RouterHistory;
};

class PageViewTracker extends React.Component<Props> {
  componentDidMount() {
    this.recordPageView(this.props.history.location);
    this.props.history.listen(this.recordPageView);
  }

  recordPageView(location) {
    if (window.analytics) {
      window.analytics.page(location.pathname, { breakpoint: getBreakpoint() });
    }
  }

  render() {
    return this.props.children;
  }
}

export default withRouter(PageViewTracker);
